/* eslint-disable */
import axios from 'axios'
// import { Message } from 'iview'
import store from '@/store'
import {
  getToken,
  setToken,
  setStore,
  setStaff,
  setTime,
  setStartTime,
  setEndTime,
  getTenantId
} from '@/libs/auth.js'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  // timeout: 5000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    // Do something before request is sent
    config.headers['tenant-id'] = getTenantId() || ''
    // 如果没有在api中定义header版本号则默认使用通用的api版本号
    // 如果有需要的单独定义版本号的在API中自行定义
    if (!config.headers['Api-Version']) {
      config.headers['Api-Version'] = 'v4.0';
    }
    if (getToken()) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */

  //  110000 没有所属分组 没有所属门店 
  response => {
    const res = response.data
    // 自定义提示标识数组
    if (res.code !== '000000') {
      // 10000x:Token认证失败
      if(res.code === '110000' ||  res.code === '100000' ){
        if(getToken()){
          setToken('')
          location.reload('/login')
        }else{
          $.toast(res.message)
        }
      }
      if (res.code === '110001') {
        $.toast('抱歉，您无权操作！')
      }  else if (res.code === '300000') {
        $.toast('系统繁忙，请稍后再试！')
      } else if (res.code === '300001') {
        $.toast(res.message)
      } else if (res.code === '300002') {
        $.toast('网络错误，请稍后再试！')
      } else if (res.data === '900000') {
        $.alert('请求存在非法行为，您将退出本系统！', function() {
          setToken('')
          location.reload('/login')
        })
      } else {
        return Promise.reject(res)
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    console.error('err' + error) // for debug
    // eslint-disable-next-line
    $.toast(error.message)
    return Promise.reject(error)
  }
)

export default service
